<div class="tag">
  <p>{{title}}</p>
  <div (click)="onRemove()" class="remove_control"></div>
</div>
